module.exports = __webpack_public_path__ + "media/SelectionSort_slow.e890e09d.mp4";